// constants import
import reactRouterConstants from 'assets/constants/reactRouterConstants';
// assets
import { IoSettingsOutline } from 'react-icons/io5';
// icons
const icons = {
  IoSettingsOutline,
};

// ==============================|| MENU SETTING - SETTING ||============================== //

const setting = {
  id: 'group-setting',
  title: 'App Setting',
  type: 'group',
  children: [
    {
      id: reactRouterConstants.SETTING,
      title: 'Setting',
      type: 'item',
      url: reactRouterConstants.SETTING,
      icon: icons.IoSettingsOutline,
      breadcrumbs: false,
    },
  ],
};

export default setting;
